import { extensionFor } from '../capture/mimeTypes';
import { diagnostics, noteEvent } from '../lib/diagnostics';
import { getSupabase, storagePathFor, uploadClip } from './supabaseClient';
import { devWarn } from '../lib/devLog';

/**
 * Web upload: fire and forget.
 *
 * Called only after the clip is already on the guest's screen. There is no
 * queue, no retry, and no failure state shown — if it lands we keep a copy, if
 * it does not the guest still has their video and nobody's evening is worse.
 *
 * Deliberately swallows everything. A rejection here must never reach the flow,
 * which is why nothing awaits it.
 */

export function uploadClipInBackground(params: {
  sessionId: string;
  blob: Blob;
  mimeType: string;
}): void {
  const path = storagePathFor(params.sessionId, extensionFor(params.mimeType), 'web');

  void (async () => {
    try {
      const supabase = await getSupabase();
      if (!supabase) return;

      const { error } = await uploadClip(supabase, path, params.blob, params.mimeType);

      if (error) {
        // Diagnostics only. Never surfaced to the guest.
        devWarn('[upload:web] failed (ignored)', error.message);
        return;
      }

      noteEvent(`web clip uploaded: ${path}`);
      diagnostics.set((prev) => ({ ...prev, uploadsConfirmed: prev.uploadsConfirmed + 1 }));
    } catch (err) {
      devWarn('[upload:web] failed (ignored)', err);
    }
  })();
}
